/** Times and dates as the work replay shows them. */

/** 0:00, 12:07, 75:30: minutes and seconds, the way a player counts. */
export const clock = (ms: number) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

/** "12 minutes 7 seconds", for a screen reader. */
export const spoken = (ms: number) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  return `${m} minute${m === 1 ? '' : 's'} ${s % 60} second${s % 60 === 1 ? '' : 's'}`;
};

/** "13 min 32 s", or "48 s" under a minute. */
export const length = (ms: number) => {
  const s = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(s / 60);
  return m ? `${m} min${s % 60 ? ` ${s % 60} s` : ''}` : `${s} s`;
};

/** "27 Oct 2026", or null for a date that isn't one. */
export const longDate = (iso: string | null | undefined): string | null => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
};

/** "dispatch-latency" as "Dispatch latency": the task's id, read as a name. */
export const taskName = (taskId: string) => {
  const words = taskId.replace(/[-_]+/g, ' ').trim();
  return words ? `${words[0].toUpperCase()}${words.slice(1)}` : 'Work task';
};
